const apis = {
    apiTip: 'Tạo khóa API để đáp ứng nhu cầu giao dịch của bạn. Để đảm bảo an toàn tài sản, không tiết lộ khóa API của bạn.',
    cjapi: 'Tạo API',
    bzm: 'Tên ghi chú',
    qx: 'Quyền hạn',
    cjrq: 'Ngày tạo',
    cz: 'Thao tác',
    ck: 'Xem',
    bj: 'Chỉnh sửa',
    sc: 'Xóa',
    mm: 'Mật khẩu (Passphrase)',
    qsrmm: 'Vui lòng nhập mật khẩu (Passphrase)',
    sjyzm: 'Mã xác minh điện thoại',
    qsryzm: 'Vui lòng nhập mã xác minh',
    yxyzm: 'Mã xác minh email',
    dzbmd: 'Danh sách trắng địa chỉ IP (tùy chọn)',
    my: 'Khóa bí mật',
    cancel: 'Hủy',
    confirm: 'Xác nhận',
    fzapi: 'Sao chép thông tin API',
    qdsc: 'Bạn có muốn xóa API {name} không?',
    tip: 'Lời khuyên',
    sccg: 'Xóa thành công!',
    yqxsc: 'Đã hủy xóa',
    tips: 'Lưu ý:',
    zdcy: 'Mỗi tài khoản chính và phụ có thể giữ tối đa 50 khóa API hoạt động.',
    qwxl: 'Không tiết lộ khóa API của bạn; liên kết khóa API với IP có thể cải thiện đáng kể bảo mật.',
    dsfbd: 'Liên kết API có quyền giao dịch và rút tiền với nền tảng của bên thứ ba có thể dẫn đến việc rò rỉ thông tin API, hãy thận trọng.',
    zdsc: 'Để bảo vệ tài sản của bạn, khóa API không được liên kết với địa chỉ IP và có quyền giao dịch hoặc rút tiền sẽ tự động bị xóa sau 14 ngày không hoạt động và sẽ cần đăng ký lại. Các khóa API đã được liên kết với IP hoặc chỉ có quyền đọc không có giới hạn thời gian.',
    dq: 'Đọc',
    jy: 'Giao dịch',
    ljcj: 'Tạo ngay',
    qsrbzm: 'Vui lòng nhập tên ghi chú',
    cjcg: 'Tạo thành công',
    czapi: 'Đặt lại API',
    cjlc: 'Nhấp để tạo khóa API > Tạo khóa API và thông tin liên quan của riêng bạn > Xem chi tiết tài liệu API > Phát triển giao dịch',
    zdbddz: 'Mỗi khóa API có thể liên kết tối đa 20 địa chỉ IP, hãy phân tách nhiều địa chỉ IP bằng dấu phẩy.',
    xgcg: 'Chỉnh sửa thành công',
  }
  
export {
    apis
  }


// WEBPACK FOOTER //
// ./src/i18n/lang/api/pt_BR.js